import { Table, Button } from "flowbite-react";
import Navbar from "./navbar";
import "../App.css";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { GlobalContext } from "../context/GlobalContext";
import { useNavigate } from "react-router-dom";
function ListJob() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [currentId, setCurrentId] = useState();
  const { data, fetchStatus, setFetchStatus, functions } =
    useContext(GlobalContext);
  const { fetchData, handleText } = functions;

  function formatRupiah(angka) {
    if (angka !== null) {
      var number_string = angka.toString(),
        split = number_string.split(","),
        sisa = split[0].length % 3,
        rupiah = split[0].substr(0, sisa),
        ribuan = split[0].substr(sisa).match(/\d{3}/gi),
        separator;

      // tambahkan titik jika yang di input sudah menjadi angka ribuan
      if (ribuan) {
        separator = sisa ? "." : "";
        rupiah += separator + ribuan.join(".");
      }

      rupiah = split[1] !== undefined ? rupiah + "," + split[1] : rupiah;
      return rupiah === "0" ? "Free" : "Rp. " + rupiah + ",-";
    }
  }
  const handleDelete = (idData) => {
    let token = Cookies.get("token");
    axios
      .delete(`https://dev-example.sanbercloud.com/api/job-vacancy/${idData}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setFetchStatus(true);
      });
  };

  const handleEdit = (idData) => {
    setCurrentId(idData);
    navigate(`/dashboard/list-job-vacancy/form/edit/${idData}`);
  };
  useEffect(() => {
    if (fetchStatus) {
      fetchData();
      setFetchStatus(false);
      setIsLoading(false);
    }
  }, [fetchStatus, setFetchStatus, fetchData]);

  return (
    <>
      {isLoading ? (
        <span className="  text-xs font-medium text-blue-800 text-center p-0.5 leading-none rounded-full px-2 dark:bg-blue-900 dark:text-blue-200 absolute -translate-y-1/2 -translate-x-1/2 top-2/4 left-1/2">
          <div role="status">
            <svg
              aria-hidden="true"
              className="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
          </div>
        </span>
      ) : (
        <div className="max-w-screen-xl  mx-auto ">
          <Table>
            <Table.Head>
              <Table.HeadCell className="bacground">NO</Table.HeadCell>
              <Table.HeadCell className="bacground">TITLE</Table.HeadCell>

              <Table.HeadCell className="bacground">
                JOB QUALIFIACATION
              </Table.HeadCell>
              <Table.HeadCell className="bacground">JOB TYPE</Table.HeadCell>
              <Table.HeadCell className="bacground">JOB TENURE</Table.HeadCell>
              <Table.HeadCell className="bacground">
                COMPANY NAME
              </Table.HeadCell>
              <Table.HeadCell className="bacground">
                COMPANY CITY
              </Table.HeadCell>
              <Table.HeadCell className="bacground">SALARY MIN</Table.HeadCell>
              <Table.HeadCell className="bacground">SALARY MAX</Table.HeadCell>
              <Table.HeadCell className="bacground">ACTION</Table.HeadCell>
            </Table.Head>
            <Table.Body className="divide-y ">
              {data !== null &&
                data.map((res) => {
                  return (
                    <>
                      <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800 ">
                        <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white bacground1">
                          {res?.id}
                        </Table.Cell>
                        <Table.Cell className="bacground1">
                          {" "}
                          {res?.title}
                        </Table.Cell>
                        <Table.Cell className="bacground1">
                          {" "}
                          {handleText(res?.job_qualification, 50)}
                        </Table.Cell>
                        <Table.Cell className="bacground1">
                          {res?.job_type}
                        </Table.Cell>
                        <Table.Cell className="bacground1">
                          {res?.job_tenure}
                        </Table.Cell>{" "}
                        <Table.Cell className="bacground1">
                          {res?.company_name}
                        </Table.Cell>{" "}
                        <Table.Cell className="bacground1">
                          {res?.company_city}
                        </Table.Cell>{" "}
                        <Table.Cell className="bacground1">
                          {formatRupiah(res?.salary_min)}
                        </Table.Cell>
                        <Table.Cell className="bacground1">
                          {formatRupiah(res?.salary_max)}
                        </Table.Cell>
                        <Table.Cell>
                          {" "}
                          <div className="flex items-center flex-row ">
                            <button
                              className=" text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                              onClick={(e) => {
                                handleEdit(res?.id);
                              }}
                              value={res?.id}
                            >
                              <svg
                                aria-hidden="true"
                                fill="none"
                                color="white"
                                class="flex-shrink-0  w-4 h-4 text-white-500 transition duration-75 dark:text-white-400 group-hover:text-gray-900 dark:group-hover:text-white"
                                stroke="currentColor"
                                stroke-width="1.5"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                              </svg>
                            </button>
                            <button
                              className=" text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                              color="failure"
                              onClick={(e) => {
                                setCurrentId(res?.id);
                                Swal.fire({
                                  title: "Apakah Kamu Yakin?",
                                  text: "Kamu Tidak Bisa Membalikan nya Lagi!",
                                  icon: "warning",
                                  showCancelButton: true,
                                  confirmButtonColor: "#3085d6",
                                  cancelButtonColor: "#d33",
                                  confirmButtonText: "Ya, Hapus itu!",
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    Swal.fire(
                                      "Deleted!",
                                      "Data kamu berhasil di hapus.",
                                      "success"
                                    );
                                    handleDelete(res?.id);
                                  }
                                });
                              }}
                              value={res?.id}
                            >
                              <svg
                                aria-hidden="true"
                                fill="none"
                                stroke="currentColor"
                                class="flex-shrink-0  w-4 h-4 text-white-500 transition duration-75 dark:text-white-400 group-hover:text-gray-900 dark:group-hover:text-white"
                                stroke-width="1.5"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                              </svg>
                            </button>
                          </div>
                        </Table.Cell>
                      </Table.Row>
                    </>
                  );
                })}
            </Table.Body>
          </Table>
        </div>
      )}
    </>
  );
}

export default ListJob;
